import {Controller} from "@/controllers/Controller";

/**
 * Controller for stats API (ms-marketing) : répartition par intention et performance des publications
 */
export class StatsController extends Controller {

    // Visé / publié / à venir
    static funnel() {
        return this.requestBuilder("GET", `/marketing/stats/funnel`, true);
    }

    // Classement et moyennes des résultats saisis
    static performance() {
        return this.requestBuilder("GET", `/marketing/stats/performance`, true);
    }
}
